import { EboObjectTO } from '../../base-classes/ebo-object-to';
import { Route } from '../route';
import { RouteGroup } from './route-group';

export class RouteGroupRoute extends EboObjectTO {
  routeGroupId: string;
  routeGroup: RouteGroup;
  routeId: string;
  route: Route;

  constructor(data: Partial<RouteGroupRoute>) {
    super(data);
    if (data) {
      if (data.routeGroup) {
        this.routeGroup = new RouteGroup(data.routeGroup);
      }
      if (data.route) {
        this.route = new Route(data.route);
      }
    }
  }
}
